export default __webpack_public_path__ + "static/media/wrong.c43d083f.png";